import React, { useState } from 'react';
import { useIsMounted } from '../../hooks/useIsMounted';
import PITLTransferModal from './PITLTransferModal';
import { logEvent } from '../../util/apiUtils';

/**
 * A button that initiates the PITL Transfer process
 */
const PITLTransferButton = ({ gearOrder, setTransferRequest }) => {
	const [showTransferModal, setShowTransferModal] = useState(false);
	const isMountedRef = useIsMounted();

	// Don't show the button if all packs have been accessioned
	const transferablePacks = gearOrder.requisitions.filter((gearReq) => !gearReq.accessionNo);
	if (transferablePacks.length === 0) {
		return null;
	}

	const showModal = (event) => {
		event?.preventDefault && event.preventDefault();
		setShowTransferModal(true);
		logEvent(
			'{} - PITL Transfer Modal opened. gearOrderId={}',
			'UI_ACTION_PITL_TRANSFER_MODAL_OPENED',
			gearOrder.id
		);
	};

	const closeModal = (event) => {
		event?.preventDefault && event.preventDefault();
		if (isMountedRef.current) {
			setShowTransferModal(false);
		}
	};

	const submitTransfer = (gearReqIds) => {
		setTransferRequest({
			action: 'transfer',
			gearReqIds: gearReqIds
		});
		logEvent(
			'{} - PITL Transfer Modal submitted. gearOrderId={}, gearReqIds={}',
			'UI_ACTION_PITL_TRANSFER_MODAL_SUBMITTED',
			gearOrder.id,
			gearReqIds.join(', ')
		);

		closeModal();
	};

	return (
		<>
			<span className="small" style={{ marginTop: '10px', marginBottom: '-15px', display: 'block' }}>
				If you're no longer planning to use your lab collection pack, you can{' '}
				<button onClick={showModal} className="btn-link btn-unstyled">
					transfer it to someone else
				</button>{' '}
				so they may use it.
			</span>
			{showTransferModal && (
				<PITLTransferModal gearOrder={gearOrder} closeModal={closeModal} onSubmit={submitTransfer} />
			)}
		</>
	);
};

export default PITLTransferButton;
